import { useEffect, useState } from 'react';
import Avatar from 'react-avatar';
import CountUp from 'react-countup';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import PropagateLoader from 'react-spinners/PropagateLoader';
import ScaleLoader from 'react-spinners/ScaleLoader';

import botImage from '../../assets/img/bot-lying.jpg';

// import alloy_logo from '../../assets/img/appraisal/alloy_logo.png';
// import colab_logo from '../../assets/img/appraisal/colab_logo.png';
// import gc_logo from '../../assets/img/appraisal/gc_logo.png';
// import kevel_logo from '../../assets/img/appraisal/kevel_logo.png';
// import trgr_logo from '../../assets/img/appraisal/trgr_logo.png';
// import westcap_logo from '../../assets/img/appraisal/westcap_logo.png';
// import yac_logo from '../../assets/img/appraisal/yac_logo.png';
import featured_1 from '../../assets/img/appraisal/featured-logo-1.png';
import featured_2 from '../../assets/img/appraisal/featured-logo-2.png';
import featured_3 from '../../assets/img/appraisal/featured-logo-3.png';
import featured_4 from '../../assets/img/appraisal/featured-logo-4.png';
import featured_5 from '../../assets/img/appraisal/featured-logo-5.png';
import featured_6 from '../../assets/img/appraisal/featured-logo-6.png';
import featured_7 from '../../assets/img/appraisal/featured-logo-7.png';
import featured_8 from '../../assets/img/appraisal/featured-logo-8.png';
import sellStatIllustration from '../../assets/img/sell_stat_illustration.png';

import why_img_1 from '../../assets/img/appraisal/why_img_1.png';
import why_img_2 from '../../assets/img/appraisal/why_img_2.png';
import why_img_3 from '../../assets/img/appraisal/why_img_3.png';
import why_img_4 from '../../assets/img/appraisal/why_img_4.png';

import Ellipse from '../../assets/img/new-design/Ellipse.png';
import { TERMS_AND_SERVICE } from '../../store/actions/types';
import { docIds, ellipseImages, getAgentName, getEllipseImage, getUserImageURL, makeAnEnquiry, scrollDoc } from '../../utils/handler';

export const LoadingPage = () => {
  const { t } = useTranslation();
  return (
    <div className="loader">
      <div className="custom-loader ">
        <PropagateLoader color={'#ff7728;'} loading={true} size={15} />
      </div>
      <div className="loader-content">{t('Working on it, Please Wait...')}</div>
    </div>
  );
};

export const RequestLoading = (props: { color?: string; size?: number; width?: number; height?: number } = { height: 5, width: 100, color: '#ff7728', size: 25 }) => {
  return <ScaleLoader aria-label="Loading Spinner" data-testid="loader" color={props.color} loading={true} height={props.height} width={props.width} />;
};
export const BotErrorPage: React.FC<{}> = (): JSX.Element => {
  return (
    <div className="text-center boat-page mt-5">
      <div>
        <div>I found your activity like bot's</div>
        <img src={botImage} alt="bot" className="bot-image" />
      </div>
    </div>
  );
};

export const ReactPagination = (payload: { currentPage: number; totalPages: number; onPageChange: any }) => {
  return payload.totalPages > 1 ? (
    <div className="float-right mb-2">
      <ReactPaginate previousLabel={'<'} nextLabel={'>'} pageCount={Math.ceil(payload.totalPages)} marginPagesDisplayed={3} pageRangeDisplayed={3} onPageChange={(e) => payload.onPageChange(e.selected + 1)} containerClassName={'pagination mt-3'} activeClassName={'active'} forcePage={payload.currentPage - 1 || 0} />
    </div>
  ) : null;
};

export const ContributedDomains = (props: any) => {
  return (
    <>
      {/* sell_hero_h5 */}
      <div className=" title ls--1_5">
        {props.addAnd ? '...& ' : ''}
        {props.smallSection ? 'We’ve been featured in:' : 'Our Team Has Contributed To $500m+ In Domain Transactions'}
      </div>
      <div className={'row contributed-domain  '}>
        <div className={'four-logo ' + (props.smallSection ? 'col-lg-12 ' : 'col-lg-6 col-md-12')}>
          <img className="img-1" src={featured_1} alt="TC" />
          <img className="img-2" src={featured_2} alt="Yahoo" />
          <img className="img-3" src={featured_3} alt="Forbes" />
          <img className="img-4" src={featured_4} alt="DNJournal" />
        </div>
        <div className={'four-logo ' + (props.smallSection ? 'col-lg-12' : 'col-lg-6 col-md-12')}>
          <img className="img-5" src={featured_5} alt="Tech" />
          <img className="img-6" src={featured_6} alt="Mashable" />
          <img className="img-7" src={featured_7} alt="Yale" />
          <img className="img-8" src={featured_8} alt="DNW" />
        </div>
      </div>
    </>
  );
};

export const Reviews = () => {
  return (
    <div className="reviews ash-bg review-bg">
      <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
        <ol className="carousel-indicators">
          <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        </ol>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="review-star">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </div>
            <div className="reviewer-name h4-title">Marc Lore | Serial Entrepreneur</div>
            <div className="review-content">"When starting a company, the saw.com team are some of the first people I call. A memorable name, and the domain and social handles behind it, creates a huge amount of brand equity right out the gate — no matter how big or how small your company is. From diapers.com to jet.com (and many more to come!) the saw.com team has helped my companies be seen."</div>
          </div>
          <div className="carousel-item">
            <div className="review-star">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </div>
            <div className="reviewer-name">James Avery | CEO | Kevel.com</div>
            <div className="review-content ">“The advice I would give is to hire a professional. We went to Saw.com to see if there was an opportunity to work with professionals to acquire Kevel.com. Why? Because we saw value in the .com. We tried and failed to acquire Kevel.com but Saw.com did not fail. They were great to work with, the start to finish was a month. They were fast and acquired it at a price we were looking for.” </div>
          </div>
          <div className="carousel-item">
            <div className="review-star">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </div>
            <div className="reviewer-name">Justin Mitchell | CEO | Yac.com</div>
            <div className="review-content">“If you’re looking to secure a powerful, trustworthy domain for your business then Saw.com is the perfect solution. At Yac.com, we know we’re operating in a highly competitive industry and need to differentiate ourselves as much as we can. We saw the value in a premium .com address and were incredibly impressed with the speed, efficiency and price at which Saw.com acquired our domain.”</div>
          </div>
        </div>
        <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
          <span>
            <i className="fas fa-chevron-circle-left fa-lg"></i>
          </span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
          <span>
            <i className="fas fa-chevron-circle-right fa-lg"></i>
          </span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
  );
};
export const GetNumbersCount = (maxNumber: number) => {
  return <CountUp end={maxNumber} duration={2} />;
};
export const StatisticsDetails = (props: any) => {
  return (
    <div className="saw-experience row">
      <div className="experience  col-6 col-md-3 vl">
        <div className="number">{GetNumbersCount(20)}</div>
        <div className="details">
          <div>Years of Experience</div>
        </div>
      </div>
      <div className="col-6 col-md-3 vl">
        <div className="number">{GetNumbersCount(1000)}+</div>
        <div className="details">
          <div>Domain Transactions</div>
        </div>
      </div>
      {props?.showDomainSales ? (
        <div className="col-6 col-md-3 vl">
          <div className="number">${GetNumbersCount(500)}m</div>
          <div className="details">
            <div>Domain Sales</div>
          </div>
        </div>
      ) : (
        <div className="col-6 col-md-3 vl">
          <div className="number">{GetNumbersCount(37)}%</div>
          <div className="details">
            <div>Average List Price Saving</div>
          </div>
        </div>
      )}
      <div className="col-6 col-md-3">
        <div className="number">{GetNumbersCount(100)}%</div>
        <div className="details">
          <div>Transparency and Commitment</div>
        </div>
      </div>
    </div>
  );
};

export const WhyChooseSaw = () => {
  return (
    <div className="row text-center why-choose-saw">
      <div className="col-lg-6 col-md-12   ">
        <img className="why-saw-img" src={why_img_1} alt="why_img_1" />
      </div>
      <div className="col-lg-6 col-md-12  text-left  saw-info ">
        <div className="h4-title">We Know What We’re Doing</div>
        <div className="normal-font">The Saw.com team is full of domain experts - and our CEO, Jeffrey Gabriel, has contributed to more than $500m in domain transitions and blockbuster sales like the record-breaking $13m for Sex.com. Our brokers are some of the brightest minds in the business, boasting years of knowledge and a proven track record of experience.</div>
      </div>
      <div className="col-12 row">
        <div className="col-lg-6 col-md-12  text-left saw-info">
          <div className="h4-title">We Work With Select Clients</div>
          <p className="normal-font">We’re discerning about who we work with, and how we can help. We only collaborate with companies who we feel can gain the most impact from our services. We’re not a high-volume shop, so you never become ‘a number on the spreadsheet’. We take time to give your business the care and attention it deserves.</p>
        </div>
        <div className="col-lg-6 col-md-12  order-first order-md-12">
          <img src={why_img_2} className="why-saw-img" alt="why_img_2" />
        </div>
      </div>

      <div className="col-lg-6 col-md-12 ">
        <img src={why_img_3} className="why-saw-img" alt="why_img_3" />
      </div>

      <div className="col-lg-6 col-md-12  text-left saw-info">
        <div className="h4-title">We Focus On Transparency</div>
        <p className="normal-font">Integrity is at our core - and, unlike other providers, Saw.com consistently ensures transparency and a seamless process in all that we do on behalf of our clients. We’ll always be upfront and honest about your domain, so if it’s not available (or the right buyer isn’t out there) we can explore alternative solutions before making a decision.</p>
      </div>
      <div className="col-12 row">
        <div className="col-lg-6 col-md-12  text-left saw-info">
          <div className="h4-title">We Have a Proven Track Record</div>
          <p className="normal-font">More than anything, you need to know that your domain transaction is being handled by experts - and that you’re going to get the results to drive your business forward. Saw.com is the industry leader in selling and buying domains and has experience like no other when it comes to every aspect of brokerage.</p>
        </div>
        <div className="col-lg-6 col-md-12  order-first order-md-12">
          <img src={why_img_4} className="why-saw-img" alt="why_img_4" />
        </div>
      </div>
    </div>
  );
};

export const BOXConsultantDetails = (consultant: any, ashBG = false, isAgentPaid = true) => {
  const dispatch = useDispatch();
  return (
    <div className={'card-body three-corner-radius flex-center card-over-img  ' + (ashBG ? ' background-ash' : '')}>
      <div className="user-image-round-background image-cover-card-top user-image">
        <Avatar size={'100'} textSizeRatio={5} round={true} name={getAgentName(consultant)} src={getUserImageURL(consultant?.image)} />
      </div>
      <div className={'content mt-3'}>
        <span className="h4-title">{consultant?.name}</span>
        <div>
          <span>Sales Consultant</span>
        </div>
        <div className="mt-2 ">
          {isAgentPaid ? (
            <>
              <div className="hover-u  c-pointer mt-2" onClick={() => window.open(`mailto:${consultant?.email}?subject=Enquiry`)}>
                <i className="theme-color far fa-envelope  "></i>
                <span className="agent-email ml-2">{consultant?.email}</span>
              </div>
              <div className="hover-u  c-pointer  mt-2" onClick={() => window.open(`tel:${consultant?.phone}`)}>
                <i className="theme-color fas fa-phone-volume  "></i>
                <span className="ml-2 agent-number">{consultant?.phone}</span>
              </div>
            </>
          ) : (
            <div className="c-default">
              <div className="mt-4">
                <i className="theme-color far fa-envelope  "></i>
                <span className="agent-email ml-2 blur-text">{'XXXXXXXXXXXX@XXXXXX'}</span>
              </div>
              <div className="mt-2">
                <i className="theme-color fas fa-phone-volume  "></i>
                <span className={'ml-2 agent-number blur-text'}>{'XXXXXXXXXXX'}</span>
              </div>
            </div>
          )}
          <div className="theme-color c-pointer  mt-3" onClick={() => dispatch({ type: TERMS_AND_SERVICE, payload: true })}>
            Agreed Terms of Service
          </div>
        </div>
        {/* <p className='mt-3'>Saw.com only collaborates with companies who we feel can gain the most impact out of our services. We’re not a high-volume shop.</p> */}
      </div>
    </div>
  );
};

export const GetEllipseImagesWithIcon = (img: string) => {
  return (
    <div className="ellipse-img-with-icon">
      <img className="ellipse" alt="saw" src={Ellipse} />
      <div className="row justify-content-center position-relative">
        <img className="ellipse-img" alt="saw" src={getEllipseImage(img)} />
      </div>
    </div>
  );
};

export const WhyChooseUs = () => {
  return (
    <div className="text-center mt-4">
      <div className="title">Why Choose Us?</div>
      <div className="container why-choose ">
        <div className="row justify-content-between">
          <div className="card-body flex-center card-over-img col-lg-5 col-md-12">
            <div className="image-cover-card-top">{GetEllipseImagesWithIcon(ellipseImages.extensive_experience)}</div>
            <div className="content">
              <span className="h4-title">Extensive Experience</span>
              <p className="mt-3">Saw.com is full of experts who have worked with recognizable brands and contributed to $500m+ in domain transitions and blockbuster sales.</p>
            </div>
          </div>
          <div className="card-body flex-center card-over-img col-lg-5 col-md-12">
            <div className="image-cover-card-top">{GetEllipseImagesWithIcon(ellipseImages.intimate_service)}</div>
            <div className="content">
              <span className="h4-title">Intimate Service</span>
              <p className="mt-3">Saw.com only collaborates with companies who we feel can gain the most impact out of our services. We’re not a high-volume shop.</p>
            </div>
          </div>
          <div className="card-body flex-center card-over-img col-lg-5 col-md-12">
            <div className="image-cover-card-top">{GetEllipseImagesWithIcon(ellipseImages.always_transparent)}</div>
            <div className="content">
              <span className="h4-title">Always Transparent</span>
              <p className="mt-3">Saw.com consistently ensures transparency, integrity and a seamless process. We’ll always be upfront and honest about your domain.</p>
            </div>
          </div>
          <div className="card-body flex-center card-over-img col-lg-5 col-md-12">
            <div className="image-cover-card-top">{GetEllipseImagesWithIcon(ellipseImages.proven_track_record)}</div>
            <div className="content">
              <span className="h4-title">Proven Track Record</span>
              <p className="mt-3">Saw.com is the industry leader in selling and buying domains and has experience like no other when it comes to every aspect of brokerage.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const SawHelpsContent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    var aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    aScript.async = true;
    document.head.appendChild(aScript);
    aScript.onload = () => {
      setShow(true);
    };
  }, []);
  return (
    <>
      <p className="mt-3">
        <span className="f-bold">Saw.com</span> helps your business purchase a premium domain for the best price. We source viable options, negotiate and acquire the ideal address for your brand.{' '}
      </p>
      <ul className="theme-bullets">
        <li>Become an authority in your field</li>
        <li>Build instant trust with your audience</li>
        <li>Create a powerful online presence</li>
      </ul>

      {show && (
        <div style={{ textAlign: 'left', height: '30px', marginTop: '20px', maxWidth: '275px' }}>
          <div className="trustpilot-widget" data-locale="en-US" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="5e4179e55dd2990001312959" data-style-height="100%" data-style-width="100%" data-theme="light" data-font-family="Poppins">
            <a href="https://www.trustpilot.com/review/saw.com" target="_blank" rel="noopener noreferrer">
              Trustpilot
            </a>
          </div>
        </div>
      )}

      <div className="help-content ">
        <ContributedDomains smallSection={true} />
      </div>
    </>
  );
};
export const DomainDeal = () => {
  return (
    <div className="row justify-content-center">
      <div className="card-body  col-lg-3 col-md-12 background-ash m-2">
        <div className="deal-model-image">
          <span className=" text-ash deal-number">1.</span>
          <img alt="" className="" src={getEllipseImage(ellipseImages.budgeting_group)}></img>
        </div>
        <div className="h4-title">Budgeting</div>
        <p>We’ll have a chat with you to discuss your business and its specific domain requirements</p>
      </div>
      <div className="card-body  col-lg-3 col-md-12 background-ash m-2">
        <div className="deal-model-image">
          <span className=" text-ash deal-number">2.</span>
          <img alt="" className="" src={getEllipseImage(ellipseImages.contact)}></img>
        </div>{' '}
        <div className="h4-title">Contact</div>
        <p>We’ll find and make contact with the owner of your perfect domain to get the ball rolling</p>
      </div>
      <div className="card-body  col-lg-3 col-md-12 background-ash m-2">
        <div className="deal-model-image">
          <span className=" text-ash deal-number">3.</span>
          <img alt="" className="" src={getEllipseImage(ellipseImages.acquire)}></img>
        </div>{' '}
        <div className="h4-title">Acquire</div>
        <p>We’ll quickly negotiate favorable terms before acquiring and transferring your chosen domain</p>
      </div>
      <div className="row justify-content-center">
        <button className=" btn-grad btn " onClick={() => scrollDoc(docIds.makeAndInquiryForm)}>
          Make An Inquiry
        </button>
      </div>
    </div>
  );
};
interface ChildProps {
  id?: string;
  disabled?: boolean;
  required?: boolean;
  name: string;
  placeholder?: string;
  value: number | string | undefined;
  className?: string;
  min?: number;
  max?: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
export const NumberInput: React.FC<ChildProps> = ({ min = 0, max, required = false, id = new Date().toString(), disabled = false, className, placeholder, onChange, name, value }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e);
  };
  // const exceptThisSymbols = ["e", "E", "+", "-", "."];

  return (
    <input
      required={required}
      id={id}
      disabled={disabled}
      autoComplete="off"
      type="number"
      className={className || 'form-control saw-input'}
      name={name}
      placeholder={placeholder || ''}
      onWheel={() => {
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
      }}
      onKeyDown={(e) => {
        [189, 69, 109, 187, 107].includes(e.keyCode) && e.preventDefault();
      }}
      value={value || ''}
      min={min}
      max={max}
      onChange={handleChange}
    />
  );
};

export const WhyTrustSaw = () => {
  //   return <div className="want-to-discuss-container  row justify-content-center">
  //   <div className="container container-with-cards">
  //     <div className="main-text">So… What Do You Do Now?</div>
  //     <label className="h3-title">Now You Know The Domain’s Value, Saw.com Can Help You With:</label>
  //     <div className="row text-center ">
  //       <div className="col-3 card p-4  ">
  //         <div>
  //           <img className="card-images" src={worldPNG} alt="Infinity" />
  //         </div>
  //         <div className="h3-title underline">Domain Acquisition</div>
  //         <p className="fs-12">Saw.com helps your business purchase a premium domain for the best price. We source viable options, negotiate and acquire the ideal address for your brand – so you end up with your perfect solution through a seamless, transparent process.</p>
  //       </div>
  //       <div className="col-3 card p-4">
  //         <div>
  //           <img className="card-images" src={searchPNG} alt="Infinity" />
  //         </div>
  //         <div className="h3-title underline">Domain Acquisition</div>
  //         <p>Our team of experts can help with all aspects of domain appraisal. Just submit your names to our brokerage and we’ll contact the domain owner. Once the appraisal is delivered, we’ll schedule a call to review the findings and consult on next steps.</p>
  //       </div>
  //       <div className="col-3 card p-4 ">
  //         <div>
  //           <img className="card-images" src={extentionPNG} alt="Infinity" />
  //         </div>
  //         <div className="h3-title underline">Portfolio Representation</div>
  //         <p>If you own a portfolio of investment-grade domains, we can optimise your sales strategy through data, infrastructure and experience. From outbound marketing to lead follow-up and everything in between, we’re a white-glove service like no other.</p>
  //       </div>
  //     </div>
  //   </div>
  //   <div className="row justify-content-center mt-5">
  //     <button className="btn btn-grad   text-uppercase" onClick={(e) => buyDomain('Buyer')}>
  //       Buy a domain
  //     </button>
  //     <button className="btn btn-primary primary-dark text-uppercase" onClick={(e) => buyDomain('Seller')}>
  //       Sell a domain
  //     </button>
  //   </div>
  // </div>
};

export const FirstFooter = () => {
  return (
    <div className="ash-bg left-behind text-white row footer-bg">
      <img alt="" className="left-behind-img" src={sellStatIllustration}></img>
      <div className=" text-center">
        <div className="">
          <div className="title text-white">Saw.com Can Help With Multiple Domain Services</div>
          <div className="d-flex justify-content-center ">
            <p className="w80">Our expert brokers leverage decades of real-world sales experience and domain industry knowledge to provide a meaningful, personalized service. If you’re looking to buy, sell or appraise a portfolio of domains, we'd love to hear from you.</p>
          </div>
          <BuySellAppraiseBTNs />
        </div>
        <StatisticsDetails showDomainSales={true} />
      </div>
    </div>
  );
};

export const BuySellAppraiseBTNs = () => {
  let history = useHistory();
  return (
    <div className="row btn-padding justify-content-center">
      <button className="btn-grad btn " onClick={() => makeAnEnquiry()}>
        {'Buy'}
      </button>
      <button className="btn-grad btn ml-3 " onClick={() => history.push('/sell')}>
        {'Sell'}
      </button>
      <button className="btn-grad btn ml-3" onClick={() => history.push('/appraisal')}>
        {'Appraise'}
      </button>
      <button className="btn-outline-light btn ml-3" onClick={() => history.push('/contact-us')}>
        {'Contact Us'}
      </button>
    </div>
  );
};
